import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React, { Children, cloneElement, isValidElement } from 'react';
import Tooltip from '../../../../molecules/Tooltip';
import { useDefaultComponentValue } from '../../../../utils/useDefaultComponentValue';
import when from '../../../../utils/when';
import InputControlPanel from '../../InputControlPanel';
const COMPONENT_NAME = 'SimpleInput';
const SimpleInput = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { className, htmlFor, floatingLabelShrink, floatingLabelClassName, floatingLabelText, controlClassName, controls, onControlsClick, asyncValidationInProgress, onInputWrapperClick, children, hasError, disabled, readOnly, multiline, sizeSmall, outline, required, displayRequiredClassName = true, inputWrapperProps = {}, tooltip } = props;
    const labelElement = when(floatingLabelText, /*#__PURE__*/ React.createElement("label", {
        className: cx('Input-labelWrapper', {
            'Input-labelWrapper--shrink': floatingLabelShrink
        }, floatingLabelClassName),
        htmlFor: htmlFor
    }, /*#__PURE__*/ React.createElement("span", {
        className: cx('Input-label', {
            'Input-label--required': displayRequiredClassName && required,
            'Input-label--shrink': floatingLabelShrink
        })
    }, floatingLabelText)));
    const inputElement = /*#__PURE__*/ React.createElement("div", {
        className: cx('Input-controlWrapper', {
            'Input-controlWrapper--shrink': floatingLabelShrink
        }, controlClassName),
        onClick: onInputWrapperClick
    }, Children.map(children, (child)=>{
        if (/*#__PURE__*/ isValidElement(child) && child.type === 'input') {
            const setRef = (el)=>{
                if (child.ref) {
                    child.ref(el);
                }
            };
            return /*#__PURE__*/ cloneElement(child, {
                ref: setRef
            });
        }
        return child;
    }));
    const input = /*#__PURE__*/ React.createElement("div", {
        className: cx('Input', {
            'Input--outline': outline
        }, {
            'Input--noLabel': !labelElement
        }, {
            'Input--error': hasError
        }, {
            'Input--disabled': disabled
        }, {
            'Input--readOnly': readOnly
        }, {
            'Input--typeMultiline': multiline
        }, {
            'Input--sizeSmall': sizeSmall
        }, className),
        ...inputWrapperProps
    }, labelElement, inputElement, asyncValidationInProgress && /*#__PURE__*/ React.createElement("div", {
        className: "Input-asyncPreloader Preloader"
    }), /*#__PURE__*/ React.createElement(InputControlPanel, {
        className: controlClassName,
        onClick: onControlsClick,
        asyncValidationInProgress: asyncValidationInProgress
    }, controls));
    if (tooltip) {
        return /*#__PURE__*/ React.createElement(Tooltip, {
            tip: input,
            place: "top",
            effect: "solid",
            eventOff: "focusout",
            hideIcon: true,
            contentClassName: "Textfield-tooltip"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "Tooltip-description"
        }, tooltip));
    } else {
        return input;
    }
};
SimpleInput.propTypes = {
    asyncValidationInProgress: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    controlClassName: PropTypes.string,
    controls: PropTypes.node,
    disabled: PropTypes.bool,
    displayRequiredClassName: PropTypes.bool,
    floatingLabelClassName: PropTypes.string,
    floatingLabelShrink: PropTypes.bool,
    floatingLabelText: PropTypes.node,
    hasError: PropTypes.bool,
    htmlFor: PropTypes.any,
    inputWrapperProps: PropTypes.any,
    multiline: PropTypes.bool,
    onControlsClick: PropTypes.func,
    onInputWrapperClick: PropTypes.func,
    outline: PropTypes.bool,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    sizeSmall: PropTypes.bool,
    tooltip: PropTypes.any
};
export default SimpleInput;
